module.exports = __webpack_public_path__ + "img/mq_start.7b6c1619.svg";